import React from 'react';
import {Navbar, Nav,NavDropdown} from 'react-bootstrap'
import '../Styles/navbar.css'

const  navbar  = ({title3, title1, title2,icon}) => {
  
  return (

    <div className="App">
        <Navbar bg="light" classname="color" expand="lg">
          <Navbar.Brand href="#INIT"><img src={icon} alt=""/> 
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
                <Nav.Link href="#INIT">inicio</Nav.Link>
                <Nav.Link href="#SERVICIOS">nosotros</Nav.Link>
                <NavDropdown title="Productos" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#FUNDAS">Bolsas Biodegradables</NavDropdown.Item>
                  <NavDropdown.Item href="#CAJAS">Cajas Alimenticias</NavDropdown.Item>
                  <NavDropdown.Item href="#ENVASES">Envases Alimenticios</NavDropdown.Item>
                  <NavDropdown.Item href="#RECIPIENTES">Recipientes</NavDropdown.Item>
              </NavDropdown>
                <Nav.Link href="#CONTACTOS">Contactos</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
    </div>
  );
}

export default navbar;